module.exports = __webpack_public_path__ + "static/media/productos_otros_arandano.3b68e372.png";